
import { FiZap, FiUsers, FiFolder, FiClock, FiEdit3, FiDownload } from "react-icons/fi";

const features = [
  {
    icon: <FiZap />,
    title: "Real-time Preview",
    description: "Instant rendering as you type.",
  },
  {
    icon: <FiUsers />,
    title: "Collaborative Editing",
    description: "Real-time teamwork for research groups.",
  },
  {
    icon: <FiFolder />,
    title: "Template Library",
    description: "Professional starts for papers, theses, and resumes.",
  },
  {
    icon: <FiClock />,
    title: "Version History",
    description: "Tracking changes and instant restoration.",
  },
  {
    icon: <FiEdit3 />,
    title: "Syntax Highlighting",
    description: "Making LaTeX editing intuitive and clean.",
  },
  {
    icon: <FiDownload />,
    title: "Export Options",
    description: "PDF, Word, and HTML (coming soon).",
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="features">
        <h2>Everything you need to write beautifully</h2>
        <div className="feature-grid">
            {features.map((feature, index) => (
                <div key={index} className="feature-card">
                    <div className="feature-icon">{feature.icon}</div>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                </div>
            ))}
        </div>
    </section>
  );
}
